import angular from 'angular';
import alertCardComponent from './alertCard.component';

let alertCardModule = angular.module('alertCard', [])

.component('alertCard', alertCardComponent)

.name;

export default alertCardModule;



// WEBPACK FOOTER //
// ./client/app/components/alertCard/alertCard.js